import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="vertical-tabs"
//
// A plain tablist for the industry angles: clicking a tab marks it selected
// and reveals its panel, hiding the others. State lives in aria-selected on
// the tab (which the styling keys off) and the hidden attribute on the panel,
// so there is nothing to restore and it works without any entry animation.
export default class extends Controller {
  static targets = ["tab", "panel"];

  select(event) {
    const index = event.currentTarget.dataset.index;
    this.tabTargets.forEach((tab) => {
      tab.setAttribute("aria-selected", tab.dataset.index === index ? "true" : "false");
    });
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.index !== index;
    });
  }
}
